var map = {
	"./books-blue.png": 598,
	"./cancel-blue.png": 599,
	"./clock-blue.png": 600,
	"./flag-blue.png": 601,
	"./gauge-blue.png": 602,
	"./lightbulb-blue.png": 603,
	"./rising-blue.png": 604
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 683;



//////////////////
// WEBPACK FOOTER
// ./assets/images/widget-icons ^\.\/.*\-blue\.png$
// module id = 683
// module chunks = 0